/**
 * Check if current Malaysia time is before 12 PM (noon).
 * Used to show warning when guru/admin submits data early.
 */
export function isBefore12PM() {
  // Malaysia is UTC+8
  const now = new Date();
  const utcHours = now.getUTCHours();
  const malaysiaHour = (utcHours + 8) % 24;
  return malaysiaHour < 12;
}

/**
 * Show a confirmation dialog if it's before 12 PM.
 * Returns true if user wants to proceed, false to cancel.
 */
export function confirmIfBeforeNoon() {
  if (!isBefore12PM()) return true;
  return window.confirm(
    "Anda menghantar sebelum 12:00 PM.\nPastikan data lengkap sebelum menghantar.\n\nTeruskan?"
  );
}
